<template>
  <div class="row" v-if="feedbackEnabled">
    <div class="col-12 text-center">
      <a
        :href="
          lang === 'en' ? 'https://loan.csuzdi.hu' : 'https://hitel.csuzdi.hu'
        "
        target="_blank"
        >{{ T.loanCalculator[lang] }}</a
      >
      |
      <a href="https://ido.csuzdi.hu" target="_blank">{{
        T.workdayCalculator[lang]
      }}</a>
      |
      <a href="https://dreamjobs.hu/hu/fizetesek" target="_blank">{{
        T.salaryRanges[lang]
      }}</a>
      |
      <a :href="maillink">{{ T.feedback[lang] }}</a>
    </div>
  </div>
</template>

<script>
import { DREAMJOBS } from "../js/main.js";
import { T } from "../js/translations";

export default {
  props: {
    lang: String,
  },
  data: function() {
    return {
      maillink: "mailto:" + atob("Y3NhYmEuZGF2aWRAY3N1emRpLmh1"),
      feedbackEnabled: !DREAMJOBS,
      T: T,
    };
  },
};
</script>



// WEBPACK FOOTER //
// Feedback.vue?7c8f3284